import { render, staticRenderFns } from "./TransactionsDashboard.vue?vue&type=template&id=c1e465d2&"
import script from "./TransactionsDashboard.vue?vue&type=script&lang=js&"
export * from "./TransactionsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports